import PrestacionGrupoValidacionesCreate from './PrestacionGrupoValidacionesCreate';
import PrestacionGrupoValidacionesShow from './PrestacionGrupoValidacionesShow';

const prestacionGrupoValidaciones = {
    create: PrestacionGrupoValidacionesCreate,
    show: PrestacionGrupoValidacionesShow,
};

export default prestacionGrupoValidaciones;

